import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { ProductCard } from './_components/ProductCard';
import { Input } from '../../components/ui/input';
import { Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShopProducts() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const category = searchParams.get('category') || 'all';
  const q = searchParams.get('q') || '';
  const [search, setSearch] = useState(q);

  useEffect(() => {
    axios.get(`${API}/shop/catalog/categories`).then(r => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (category !== 'all') params.category = category;
    if (q) params.search = q;
    axios.get(`${API}/shop/catalog`, { params }).then(r => setProducts(r.data)).finally(() => setLoading(false));
  }, [category, q]);

  const setCat = (cat) => {
    const next = new URLSearchParams(searchParams);
    if (cat === 'all') next.delete('category'); else next.set('category', cat);
    setSearchParams(next);
  };

  const onSearch = (e) => {
    e.preventDefault();
    const next = new URLSearchParams(searchParams);
    if (search) next.set('q', search); else next.delete('q');
    setSearchParams(next);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="flex flex-col md:flex-row md:items-center gap-3 mb-6">
        <h1 className="text-3xl font-serif font-bold">All Products</h1>
        <form onSubmit={onSearch} className="md:ml-auto md:w-80 relative" data-testid="products-search-form">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search products..." className="pl-9" data-testid="products-search-input" />
        </form>
      </div>

      {/* Category chips */}
      <div className="flex flex-wrap gap-2 mb-6">
        <button onClick={() => setCat('all')} className={`px-4 py-1.5 rounded-full text-sm border transition ${category==='all' ? 'bg-primary text-primary-foreground border-primary' : 'border-border hover:border-primary'}`} data-testid="cat-chip-all">All</button>
        {categories.map(cat => (
          <button key={cat} onClick={() => setCat(cat)} className={`px-4 py-1.5 rounded-full text-sm border transition ${category===cat ? 'bg-primary text-primary-foreground border-primary' : 'border-border hover:border-primary'}`} data-testid={`cat-chip-${cat}`}>{cat}</button>
        ))}
      </div>

      {loading ? (
        <div className="text-center py-12 text-muted-foreground">Loading…</div>
      ) : products.length === 0 ? (
        <div className="text-center py-16 text-muted-foreground" data-testid="empty-products">No products match your search.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="products-grid">
          {products.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
